var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":"is-secondary export","loading":_vm.exporting,"size":"is-small","rounded":"","outlined":""},on:{"click":_vm.exportDefault}},[_c('svg-icon',{staticClass:"icon is-small",attrs:{"icon":"export"}}),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.export')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }